import { COOKIE_BROADBAND_ORDER, COOKIE_BROADBAND_SEARCH } from '@/constants/cookies';
import { getBroadbandBundle, getBroadbandSearch } from '@/graphql/queries/broadband';
import lang from '@/lang/middleware/products/broadband';

export default async ({ $apolloQuery, $config, $cookies, app, $phone, redirect, route, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const bundleCode = route.params.code;
  const searchCode = $cookies.get(COOKIE_BROADBAND_SEARCH);
  if (searchCode) {
    await $apolloQuery(getBroadbandSearch, { code: searchCode }).then(search => {
      if (search.address) {
        store.commit('utils/setAddress', search.address);
        delete search.address;
      }
      store.commit('search/set', search);
    }).catch(_ => {
      return redirect(app.localePath('/compare-tv-broadband-phone/'));
    });
  }
  await $apolloQuery(getBroadbandBundle, { code: bundleCode }).then(bundle => {
    $cookies.remove(COOKIE_BROADBAND_ORDER);
    const subtitle = store.$i18n.t('apply.jumbotron.subtitle', { phone: $phone($config.phone) });
    const title = store.$i18n.t('apply.jumbotron.title');
    store.commit('jumbotron/SET_JUMBOTRON', { subtitle, title, type: 'generic' });
    store.commit('pageContent/setHead', { title: [bundle.institution.name, bundle.name].join(' ') });
    store.commit('products/set', bundle);
    store.commit('order/reset', { type: 'broadband' });
  }).catch(_ => {
    redirect(301, app.localePath('/compare-tv-broadband-phone/'), { flashClass: 'error', flashMessage: store.$i18n.t('bundleNotFound') });
  });
};
